import {
    OPEN_AUTH_MODAL, CLOSE_AUTH_MODAL, OPEN_UPDATE_PROFILE_MODAL, CLOSE_UPDATE_PROFILE_MODAL,
    OPEN_BULK_ORDER_MODAL, CLOSE_BULK_ORDER_MODAL,
    SET_HISTORY, SET_DELIVERY_LOCATION, SET_NEAREST_OUTLET, SET_SEARCH_TEXT, SET_FOOD_PREFRENCE
} from './type'
import * as yup from 'yup';
import { headingDistanceTo } from 'geolocation-utils'

export const openAuthModal = () => {
    return {
        type: OPEN_AUTH_MODAL
    }
}

export const closeAuthModal = () => {
    return {
        type: CLOSE_AUTH_MODAL
    }
}

export const openUpdateProfileModal = () => {
    return {
        type: OPEN_UPDATE_PROFILE_MODAL
    }
}

export const closeUpdateProfileModal = () => {
    return {
        type: CLOSE_UPDATE_PROFILE_MODAL
    }
}

export const openBulkOrderPopUp = () => {
    return {
        type: OPEN_BULK_ORDER_MODAL
    }
}

export const closeBulkOrderPopUp = () => {
    return {
        type: CLOSE_BULK_ORDER_MODAL
    }
}

export const setHistory = (data) => {
    return {
        type: SET_HISTORY,
        payload: data
    }
}

export const setNearestOutlet = (outletId) => {
    return {
        type: SET_NEAREST_OUTLET,
        payload: outletId
    }
}



export const setLocation = (data) => (dispatch, getState) => {
    const outletsObj = getState().outlets
    const outlets = []

    const payload = {
        location: data.location,
        coordinates: {
            lat: data.coordinates.lat,
            lng: data.coordinates.lng
        }
    }

    for (let key in outletsObj) {
        const geo = outletsObj[key].address.coordinates
        const item = { id: key, ...geo }
        outlets.push(item)
    }


    // ==================================
    //  doing outlets calculations here doing 10KM = 10*1000 Meters
    // ==================================

    let nearestOutlet = null
    let nearestDistance = null

    outlets.forEach((outlet) => {
        const outletLocation = { lat: outlet.lat, lon: outlet.lng }
        const choosedLocation = { lat: data.coordinates.lat, lon: data.coordinates.lng }
        const distance = headingDistanceTo(outletLocation, choosedLocation).distance // in meters
        if (nearestDistance && distance < 10000 && distance < nearestDistance) {
            nearestOutlet = outlet.id
            nearestDistance = distance
        } else if (distance < 10000) {
            nearestDistance = distance
            nearestOutlet = outlet.id
        }
        // console.log(distance, outlet.id);
    })

    // console.log(nearestDistance, nearestOutlet);

    dispatch(setNearestOutlet(nearestOutlet))

    window.localStorage.setItem('deliveryAddress', JSON.stringify(data))

    dispatch({
        type: SET_DELIVERY_LOCATION,
        payload: payload
    })
}



export const getLocation = () => (dispatch) => {

    let schema = yup.object().shape({
        location: yup.string().required().default(() => 'Chandigarh, India'),
        coordinates: yup.object().shape({
            lat: yup.number().required().default(() => 30.7333148),
            lng: yup.number().required().default(() => 76.7794179)
        })
    });

    try {
        const localData = window.localStorage.getItem('deliveryAddress')
        window.localStorage.removeItem('deliveryAddress')
        const deliveryAddress = JSON.parse(localData)

        schema.isValid(deliveryAddress).then((valid) => {

            if (valid) {
                const x = schema.cast(deliveryAddress)
                dispatch(setLocation(x))

            } else {
                throw new Error('invalid')
            }
        }).catch((e) => {
            // console.log('then catch');
            const x = schema.cast({})
            dispatch(setLocation(x))
        })

    } catch (e) {
        // console.log('try catch');
        const x = schema.cast({})
        dispatch(setLocation(x))
    }
}


export const setSearchText = (text) => {
    return {
        type: SET_SEARCH_TEXT,
        payload: text
    }
}

export const setFoodPrefrence = (type) => {
    return {
        type: SET_FOOD_PREFRENCE,
        payload: type
    }
}